import React from 'react';

import { translate } from 'services/i18nService';

import styles from './LegalArea.css';


function LegalArea() {
  return (
    <div className={styles.legalWrapper}>
      <div className={styles.legal}>{translate('v2profile.profile.legal.area')}</div>
    </div>
  );
}

export default LegalArea;
